import { render, staticRenderFns } from "./ModalEvents.vue?vue&type=template&id=08cd04f0&scoped=true&"
import script from "./ModalEvents.vue?vue&type=script&lang=js&"
export * from "./ModalEvents.vue?vue&type=script&lang=js&"
import style0 from "./ModalEvents.vue?vue&type=style&index=0&id=08cd04f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cd04f0",
  null
  
)

export default component.exports